export default __webpack_public_path__ + "static/media/wikitree.7bffea31.png";